<template>
    <h1>Maintain View</h1>
</template>
<script>
export default {
    name: 'MaintainView',
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="scss" scoped=""></style>
